import OrderRoutes from './router';
import OrderActions from './actions';
import OrderService from './service';
import Category from './category/category';
import SubCategory from './sub-category/sub-category';
import Product from './product/product';
import ProductDetail from './product/detail';
import ProductReview from './product/review';
import Cart from './cart/cart';
import guestCart from './cart/guestCart';
import StoreDetail from './store-detail/store-detail';
import Delivery from './delivery/delivery';
import guestDelivery from './delivery/guestDelivery';
import accessibility from './accessibility/accessibility';
import DeliveryAddress from './delivery/address';
import CardDetail from './payment/card-detail';
import PaymentSuccess from './payment/order-detail';
import PaymentFailure from './payment/failure';
import RecentOrder from './recent-order/recent-order';
import SavingsClub from './savings-club/savings-club';
import Search from './search/search';
import StoreLocator from './storelocator/storelocator';
import Subscription from './subscription/subscription';
import SubscriptionProducts from './subscription/subscription-product';
import ProductsDetail from './subscription/product-detail';
import SubscriptionDetail from './subscription-detail/subscription-detail';
import SubscriptionSuccess from './subscription-detail/subscription-success';
import cardsManagement from './cards-management/cards-management';
import giftCard from './gift-card/gift-card';
import appConstants from './constants';
import paymentDetail from './payment/payment-detail';
import tsysPayment from './payment/tsys-payment';
import monerisPayment from './payment/moneris-payment';
import cardUpdate from './cards-management/card-update';

export default angular.module('app.order', [])
  .config(OrderRoutes)
  .value('orderActions', OrderActions)
  .factory('orderService', OrderService)
  .constant('APP', appConstants)
  .component('category', Category)
  .component('subCategory', SubCategory)
  .component('product', Product)
  .component('productDetail', ProductDetail)
  .component('productReview', ProductReview)
  .component('cart', Cart)
  .component('storeDetail', StoreDetail)
  .component('delivery', Delivery)
  .component('deliveryAddress', DeliveryAddress)
  .component('cardDetail', CardDetail)
  .component('paymentSuccess', PaymentSuccess)
  .component('paymentFailure', PaymentFailure)
  .component('recentOrder', RecentOrder)
  .component('savingsClub', SavingsClub)
  .component('search', Search)
  .component('storelocator', StoreLocator)
  .component('subscription', Subscription)
  .component('subscriptionProducts', SubscriptionProducts)
  .component('productsDetail', ProductsDetail)
  .component('subscriptionDetail', SubscriptionDetail)
  .component('subscriptionSuccess', SubscriptionSuccess)
  .component('cardsManagement',cardsManagement)
  .component('giftCard',giftCard)
  .component('paymentDetail',paymentDetail)
  .component('tsysPayment',tsysPayment)
  .component('monerisPayment',monerisPayment)
  .component('cardUpdate',cardUpdate)
  .component('guestcart', guestCart)
  .component('guestdelivery', guestDelivery)
  .component('accessibility', accessibility)
  
   .filter('trustAsResourceUrl', ['$sce', function($sce) {
    return function(val) {
        return $sce.trustAsResourceUrl(val);
    };
  }]);



// WEBPACK FOOTER //
// ./src/app/order/main.js